var map = {
	"./anthracite-pillow/anthracite-l.png": 1497,
	"./anthracite-pillow/anthracite-m.png": 1498,
	"./anthracite-pillow/cert-cover.webp": 1499,
	"./anthracite-pillow/cert-filler.webp": 1500,
	"./anthracite-pillow/cert-product-mob.webp": 1501,
	"./anthracite-pillow/cert-product.webp": 1502,
	"./anthracite-pillow/cover-bg.webp": 2645,
	"./anthracite-pillow/cover-product-mob.webp": 1503,
	"./anthracite-pillow/cover-product.webp": 1504,
	"./anthracite-pillow/details-product-mob.webp": 2646,
	"./anthracite-pillow/details-product.webp": 2647,
	"./anthracite-pillow/filler-bg.webp": 2648,
	"./anthracite-pillow/hero-bg-mob.webp": 2649,
	"./anthracite-pillow/hero-bg.webp": 2650,
	"./anthracite-pillow/hero-product-mob.webp": 1505,
	"./anthracite-pillow/hero-product.webp": 1506,
	"./anthracite-pillow/slide-1-mob.webp": 1507,
	"./anthracite-pillow/slide-1.webp": 1508,
	"./anthracite-pillow/slide-2-mob.webp": 1509,
	"./anthracite-pillow/slide-2.webp": 1510,
	"./anthracite-pillow/slide-3-mob.webp": 1511,
	"./anthracite-pillow/slide-3.webp": 1512,
	"./aquarius-pillow/b+control.png": 1513,
	"./aquarius-pillow/cover-product-mob.webp": 1514,
	"./aquarius-pillow/cover-product.webp": 1515,
	"./aquarius-pillow/details-product-mob.webp": 2651,
	"./aquarius-pillow/details-product.webp": 2652,
	"./aquarius-pillow/features-product-mob.webp": 1516,
	"./aquarius-pillow/features-product.webp": 1517,
	"./aquarius-pillow/hero-bg-mob.webp": 1518,
	"./aquarius-pillow/hero-bg.webp": 1519,
	"./aquarius-pillow/memory-bg-mob.webp": 1520,
	"./aquarius-pillow/memory-bg.webp": 1521,
	"./aquarius-pillow/real-example-mob.webp": 1522,
	"./aquarius-pillow/real-example.webp": 1523,
	"./atlantis-pillow/cover-product-mob.webp": 1524,
	"./atlantis-pillow/cover-product.webp": 1525,
	"./atlantis-pillow/details-product-mob.webp": 2653,
	"./atlantis-pillow/details-product.webp": 2654,
	"./atlantis-pillow/features-product-mob.webp": 1526,
	"./atlantis-pillow/features-product.webp": 1527,
	"./atlantis-pillow/hero-bg-mob.webp": 1528,
	"./atlantis-pillow/hero-bg.webp": 1529,
	"./atlantis-pillow/memory-bg-mob.webp": 1530,
	"./atlantis-pillow/memory-bg.webp": 1531,
	"./atlantis-pillow/oxygel.png": 1532,
	"./atlantis-pillow/real-example-mob.webp": 1533,
	"./atlantis-pillow/real-example.webp": 1534,
	"./calendar/animation.png": 2655,
	"./calendar/calendar-1-mob.jpg": 1535,
	"./calendar/calendar-1.jpg": 1536,
	"./calendar/calendar-2-mob.jpg": 1537,
	"./calendar/calendar-2.jpg": 1538,
	"./calendar/calendar-3-mob.jpg": 1539,
	"./calendar/calendar-3.jpg": 1540,
	"./calendar/calendar-4-mob.jpg": 1541,
	"./calendar/calendar-4.jpg": 1542,
	"./calendar/calendar-5-mob.jpg": 1543,
	"./calendar/calendar-5.jpg": 1544,
	"./calendar/calendar-mob.jpg": 2656,
	"./calendar/calendar.jpg": 1304,
	"./calendar/hero-bg-mob.png": 1545,
	"./calendar/hero-bg.png": 1546,
	"./calendar/slide-1.jpg": 1305,
	"./calendar/slide-2.jpg": 1306,
	"./calendar/slide-3.jpg": 1307,
	"./calendar/slide-4.jpg": 1308,
	"./calendar/slide-5.jpg": 1309,
	"./calendar/slide-6.jpg": 1310,
	"./calendar/star-bg-mob.png": 1547,
	"./calendar/star-bg.png": 1548,
	"./calendar/sun-1.png": 1311,
	"./calendar/sun-2.png": 1312,
	"./carpets/ardor-hero_lg.webp": 1549,
	"./carpets/ardor-hero_md.webp": 1550,
	"./carpets/ardor-hero_mob.webp": 1551,
	"./carpets/ardor-hero_tab.webp": 1552,
	"./carpets/ardor-hero_xl.webp": 1553,
	"./carpets/ardor_lg.webp": 1554,
	"./carpets/ardor_md.webp": 1555,
	"./carpets/ardor_mob.webp": 1556,
	"./carpets/ardor_tab.webp": 1557,
	"./carpets/ardor_xl.webp": 1558,
	"./carpets/barva-beige-icon.webp": 1559,
	"./carpets/barva-beige.webp": 1560,
	"./carpets/barva-grey-icon.webp": 1561,
	"./carpets/barva-grey.webp": 1562,
	"./carpets/bouddi-ecru-icon.webp": 1563,
	"./carpets/bouddi-ecru.webp": 1564,
	"./carpets/bouddi-grey-icon.webp": 1565,
	"./carpets/bouddi-grey.webp": 1566,
	"./carpets/brume-hero_lg.webp": 1567,
	"./carpets/brume-hero_md.webp": 1568,
	"./carpets/brume-hero_mob.webp": 1569,
	"./carpets/brume-hero_tab.webp": 1570,
	"./carpets/brume-hero_xl.webp": 1571,
	"./carpets/brume_lg.webp": 1572,
	"./carpets/brume_md.webp": 1573,
	"./carpets/brume_mob.webp": 1574,
	"./carpets/brume_tab.webp": 1575,
	"./carpets/brume_xl.webp": 1576,
	"./carpets/dufour-beige-icon.webp": 1577,
	"./carpets/dufour-beige.webp": 1578,
	"./carpets/dufour-brown-icon.webp": 1579,
	"./carpets/dufour-brown.webp": 1580,
	"./carpets/dufour-grey-icon.webp": 1581,
	"./carpets/dufour-grey.webp": 1582,
	"./carpets/durable-icon.webp": 1244,
	"./carpets/footer-bg_lg.webp": 1583,
	"./carpets/footer-bg_md.webp": 1584,
	"./carpets/footer-bg_mob.webp": 1585,
	"./carpets/footer-bg_tab.webp": 1586,
	"./carpets/footer-bg_xl.webp": 1587,
	"./carpets/gleam-hero_lg.webp": 1588,
	"./carpets/gleam-hero_md.webp": 1589,
	"./carpets/gleam-hero_mob.webp": 1590,
	"./carpets/gleam-hero_tab.webp": 1591,
	"./carpets/gleam-hero_xl.webp": 1592,
	"./carpets/gleam_lg.webp": 1593,
	"./carpets/gleam_md.webp": 1594,
	"./carpets/gleam_mob.webp": 1595,
	"./carpets/gleam_tab.webp": 1596,
	"./carpets/gleam_xl.webp": 1597,
	"./carpets/hero_lg.webp": 1598,
	"./carpets/hero_md.webp": 1599,
	"./carpets/hero_mob.webp": 1600,
	"./carpets/hero_tab.webp": 1601,
	"./carpets/hero_xl.webp": 1602,
	"./carpets/kelso-beige-icon.webp": 1603,
	"./carpets/kelso-beige.webp": 1604,
	"./carpets/kelso-brown-icon.webp": 1605,
	"./carpets/kelso-brown.webp": 1606,
	"./carpets/kufri-beige-icon.webp": 1607,
	"./carpets/kufri-beige.webp": 1608,
	"./carpets/kufri-ecru-icon.webp": 1609,
	"./carpets/kufri-ecru.webp": 1610,
	"./carpets/kufri-grey-icon.webp": 1611,
	"./carpets/kufri-grey.webp": 1612,
	"./carpets/kufri-grey1-icon.webp": 1613,
	"./carpets/kufri-grey1.webp": 1614,
	"./carpets/micropolyester_mob.webp": 1615,
	"./carpets/mircopolyester_lg.webp": 1616,
	"./carpets/mircopolyester_md.webp": 1617,
	"./carpets/mircopolyester_tab.webp": 1618,
	"./carpets/mircopolyester_xl.webp": 1619,
	"./carpets/natural-icon.webp": 1620,
	"./carpets/palani-brown-icon.webp": 1621,
	"./carpets/palani-brown.webp": 1622,
	"./carpets/palani-ecru-icon.webp": 1623,
	"./carpets/palani-ecru.webp": 1624,
	"./carpets/palani-grey-icon.webp": 1625,
	"./carpets/palani-grey.webp": 1626,
	"./carpets/resistance-icon.webp": 1627,
	"./carpets/sensotex_lg.webp": 1628,
	"./carpets/sensotex_md.webp": 1629,
	"./carpets/sensotex_mob.webp": 1630,
	"./carpets/sensotex_tab.webp": 1631,
	"./carpets/sensotex_xl.webp": 1632,
	"./carpets/shimla-brown-icon.webp": 1633,
	"./carpets/shimla-brown.webp": 1634,
	"./carpets/shimla-grey-icon.webp": 1635,
	"./carpets/shimla-grey.webp": 1636,
	"./carpets/soft-icon.webp": 1637,
	"./carpets/strong-icon.webp": 1313,
	"./carpets/wool-icon.webp": 1638,
	"./carpets/wool_lg.webp": 1639,
	"./carpets/wool_md.webp": 1640,
	"./carpets/wool_mob.webp": 1641,
	"./carpets/wool_tab.webp": 1642,
	"./carpets/wool_xl.webp": 1643,
	"./cuprum-pillow/cover-product-mob.webp": 1644,
	"./cuprum-pillow/cover-product.webp": 1645,
	"./cuprum-pillow/cuprum.png": 1646,
	"./cuprum-pillow/details-product-mob.webp": 2657,
	"./cuprum-pillow/details-product.webp": 2658,
	"./cuprum-pillow/features-product-mob.webp": 1647,
	"./cuprum-pillow/features-product.webp": 1648,
	"./cuprum-pillow/hero-bg-mob.webp": 1649,
	"./cuprum-pillow/hero-bg.webp": 1650,
	"./cuprum-pillow/memory-bg-mob.webp": 1651,
	"./cuprum-pillow/memory-bg.webp": 1652,
	"./cuprum-pillow/real-example-mob.webp": 1653,
	"./cuprum-pillow/real-example.webp": 1654,
	"./element-pillow/cover-product-mob.webp": 1655,
	"./element-pillow/cover-product.webp": 1656,
	"./element-pillow/details-product-mob.webp": 2659,
	"./element-pillow/details-product.webp": 2660,
	"./element-pillow/features-product-mob.webp": 1657,
	"./element-pillow/features-product.webp": 1658,
	"./element-pillow/germanium.png": 1659,
	"./element-pillow/hero-bg-mob.webp": 1660,
	"./element-pillow/hero-bg.webp": 1661,
	"./element-pillow/memory-bg-mob.webp": 1662,
	"./element-pillow/memory-bg.webp": 1663,
	"./element-pillow/real-example-mob.webp": 1664,
	"./element-pillow/real-example.webp": 1665,
	"./icons/100-cotton.svg": 1245,
	"./icons/300-thread-count.svg": 1218,
	"./icons/370-thread-count.svg": 1666,
	"./icons/700-fill-power.svg": 1667,
	"./icons/800-500-fill-power.svg": 1668,
	"./icons/800-fill-power.svg": 1669,
	"./icons/adjustble-height.svg": 1670,
	"./icons/all-season.svg": 1246,
	"./icons/anatomic-cooling.svg": 1314,
	"./icons/back-sleeper-black.svg": 1184,
	"./icons/back-sleeper.svg": 1174,
	"./icons/bacteriostatic-effect-black.svg": 1247,
	"./icons/bacteriostatic-effect.svg": 1185,
	"./icons/bed-bug-free.svg": 1671,
	"./icons/breathable-black.svg": 1672,
	"./icons/breathable.svg": 1150,
	"./icons/chemical-free.svg": 1186,
	"./icons/climafiber-logo.svg": 1673,
	"./icons/climate-control-black.svg": 1674,
	"./icons/climate-control.svg": 1175,
	"./icons/cooling-effect.svg": 1675,
	"./icons/cotton-silk.svg": 1248,
	"./icons/daunasan.png": 1676,
	"./icons/double-case.svg": 1315,
	"./icons/downproof.svg": 1249,
	"./icons/dust-mite-free.svg": 1176,
	"./icons/eco-friendly.svg": 1250,
	"./icons/ergonomic-pillow.svg": 1677,
	"./icons/exclusive-design.svg": 1219,
	"./icons/farmers-down.svg": 1220,
	"./icons/firmness.png": 1187,
	"./icons/fp500.png": 1251,
	"./icons/fp500.svg": 1252,
	"./icons/fp650.png": 1253,
	"./icons/fp650.svg": 1254,
	"./icons/fp800.png": 1255,
	"./icons/fp800.svg": 1256,
	"./icons/grey-canadian-goose-down.svg": 1678,
	"./icons/healing-effect.svg": 1316,
	"./icons/height.png": 1188,
	"./icons/hydroscopic-absorption-black.svg": 1257,
	"./icons/hydroscopic-absorption.svg": 1144,
	"./icons/hypoallergenic-black.svg": 1679,
	"./icons/hypoallergenic.svg": 1317,
	"./icons/immune-support-black.svg": 1680,
	"./icons/left-line.svg": 1151,
	"./icons/light.svg": 1258,
	"./icons/machine-washable.svg": 1318,
	"./icons/materials.png": 1189,
	"./icons/mazurian-white-free.svg": 1681,
	"./icons/memory-effect-black.svg": 1190,
	"./icons/needle.svg": 1152,
	"./icons/nomite.png": 1682,
	"./icons/oekotex.png": 1168,
	"./icons/right-line.svg": 1153,
	"./icons/san-pro-care.png": 1683,
	"./icons/side-sleeper-black.svg": 1191,
	"./icons/side-sleeper.svg": 1177,
	"./icons/signature.svg": 1154,
	"./icons/silk.svg": 1319,
	"./icons/soft-filling.svg": 1684,
	"./icons/stomach-sleeper.svg": 1178,
	"./icons/thermal-conductivity.svg": 1259,
	"./icons/thermoregulation-black.svg": 1260,
	"./icons/thermoregulation.svg": 1685,
	"./icons/warm.svg": 1261,
	"./icons/white-goose-down.svg": 1320,
	"./infinity-duvet/cert-cover.webp": 1686,
	"./infinity-duvet/cert-filler.webp": 1687,
	"./infinity-duvet/cert-product-mob.webp": 1688,
	"./infinity-duvet/cert-product.webp": 1689,
	"./infinity-duvet/cover-bg.webp": 2661,
	"./infinity-duvet/cover-product-mob.webp": 2662,
	"./infinity-duvet/cover-product.webp": 2663,
	"./infinity-duvet/details-product-mob.webp": 2664,
	"./infinity-duvet/details-product.webp": 2665,
	"./infinity-duvet/filler-bg.webp": 2666,
	"./infinity-duvet/hero-bg-mob.webp": 2667,
	"./infinity-duvet/hero-bg.webp": 2668,
	"./infinity-duvet/hero-product-mob.webp": 1690,
	"./infinity-duvet/hero-product.webp": 1691,
	"./infinity-duvet/slide-1-mob.webp": 1692,
	"./infinity-duvet/slide-1.webp": 1693,
	"./infinity-duvet/slide-2-mob.webp": 1694,
	"./infinity-duvet/slide-2.webp": 1695,
	"./infinity-duvet/slide-3-mob.webp": 1696,
	"./infinity-duvet/slide-3.webp": 1697,
	"./infinity-pillow/cert-cover.webp": 1698,
	"./infinity-pillow/cert-filler.webp": 1699,
	"./infinity-pillow/cert-product-mob.webp": 1700,
	"./infinity-pillow/cert-product.webp": 1701,
	"./infinity-pillow/cover-bg.webp": 2669,
	"./infinity-pillow/cover-product-mob.webp": 1702,
	"./infinity-pillow/cover-product.webp": 1703,
	"./infinity-pillow/details-product-mob.webp": 2670,
	"./infinity-pillow/details-product.webp": 2671,
	"./infinity-pillow/filler-bg.webp": 2672,
	"./infinity-pillow/hero-bg-mob.webp": 2673,
	"./infinity-pillow/hero-bg.webp": 2674,
	"./infinity-pillow/hero-product-mob.webp": 1704,
	"./infinity-pillow/hero-product.webp": 1705,
	"./infinity-pillow/slide-1-mob.webp": 1706,
	"./infinity-pillow/slide-1.webp": 1707,
	"./infinity-pillow/slide-2-mob.webp": 1708,
	"./infinity-pillow/slide-2.webp": 1709,
	"./infinity-pillow/slide-3-mob.webp": 1710,
	"./infinity-pillow/slide-3.webp": 1711,
	"./innotex-duvet/cert-cover.webp": 1712,
	"./innotex-duvet/cert-filler.webp": 1713,
	"./innotex-duvet/cert-product-mob.webp": 1714,
	"./innotex-duvet/cert-product.webp": 1715,
	"./innotex-duvet/cover-bg.webp": 2675,
	"./innotex-duvet/cover-product-mob.webp": 1321,
	"./innotex-duvet/cover-product.webp": 1322,
	"./innotex-duvet/details-product-mob.webp": 2676,
	"./innotex-duvet/details-product.webp": 2677,
	"./innotex-duvet/filler-bg.webp": 2678,
	"./innotex-duvet/hero-bg-mob.webp": 2679,
	"./innotex-duvet/hero-bg.webp": 2680,
	"./innotex-duvet/hero-product-mob.webp": 1716,
	"./innotex-duvet/hero-product.webp": 1717,
	"./innotex-duvet/slide-1-mob.webp": 1718,
	"./innotex-duvet/slide-1.webp": 1719,
	"./innotex-duvet/slide-2-mob.webp": 1720,
	"./innotex-duvet/slide-2.webp": 1721,
	"./innotex-duvet/slide-3-mob.webp": 1722,
	"./innotex-duvet/slide-3.webp": 1723,
	"./kaiser-pillow/cert-cover.webp": 2681,
	"./kaiser-pillow/cert-filler.webp": 2682,
	"./kaiser-pillow/cert-product-mob.webp": 2683,
	"./kaiser-pillow/cert-product.webp": 2684,
	"./kaiser-pillow/cover-bg.webp": 2685,
	"./kaiser-pillow/cover-product-mob.webp": 1724,
	"./kaiser-pillow/cover-product.webp": 1725,
	"./kaiser-pillow/details-product-mob.webp": 2686,
	"./kaiser-pillow/details-product.webp": 2687,
	"./kaiser-pillow/filler-bg.webp": 2688,
	"./kaiser-pillow/hero-bg-mob.webp": 2689,
	"./kaiser-pillow/hero-bg.webp": 2690,
	"./kaiser-pillow/hero-product-mob.webp": 1726,
	"./kaiser-pillow/hero-product.webp": 1727,
	"./kaiser-pillow/slide-1-mob.webp": 1728,
	"./kaiser-pillow/slide-1.webp": 1729,
	"./kaiser-pillow/slide-2-mob.webp": 1730,
	"./kaiser-pillow/slide-2.webp": 1731,
	"./kaiser-pillow/slide-3-mob.webp": 1732,
	"./kaiser-pillow/slide-3.webp": 1733,
	"./mattresses/cert_lg.webp": 1734,
	"./mattresses/cert_md.webp": 1735,
	"./mattresses/cert_mob.webp": 1736,
	"./mattresses/cert_tab.webp": 1737,
	"./mattresses/cert_xl.webp": 1738,
	"./mattresses/firmness_3.svg": 1739,
	"./mattresses/firmness_4.svg": 1323,
	"./mattresses/handcraft_lg.webp": 2691,
	"./mattresses/handcraft_md.webp": 2692,
	"./mattresses/handcraft_mob.webp": 2693,
	"./mattresses/handcraft_tab.webp": 1740,
	"./mattresses/handcraft_xl.webp": 2694,
	"./mattresses/harmony-mattress/harmony_lg.mp4": 1741,
	"./mattresses/harmony-mattress/harmony_md.mp4": 1742,
	"./mattresses/harmony-mattress/harmony_mob.mp4": 1743,
	"./mattresses/harmony-mattress/harmony_tab.mp4": 1744,
	"./mattresses/harmony-mattress/harmony_xl.mp4": 1745,
	"./mattresses/harmony-mattress/hero_lg.webp": 2695,
	"./mattresses/harmony-mattress/hero_md.webp": 2696,
	"./mattresses/harmony-mattress/hero_mob.webp": 2697,
	"./mattresses/harmony-mattress/hero_tab.webp": 2698,
	"./mattresses/harmony-mattress/hero_xl.webp": 2699,
	"./mattresses/harmony-mattress/scheme_lg.webp": 1746,
	"./mattresses/harmony-mattress/scheme_md.webp": 1747,
	"./mattresses/harmony-mattress/scheme_mob.webp": 1748,
	"./mattresses/harmony-mattress/scheme_tab.webp": 1749,
	"./mattresses/harmony-mattress/scheme_xl.webp": 1750,
	"./mattresses/harmony-mattress/support_lg.webp": 1751,
	"./mattresses/harmony-mattress/support_md.webp": 1752,
	"./mattresses/harmony-mattress/support_mob.webp": 1753,
	"./mattresses/harmony-mattress/support_tab.webp": 1754,
	"./mattresses/harmony-mattress/support_xl.webp": 1755,
	"./mattresses/harmony-mattress/tech_lg.webp": 1756,
	"./mattresses/harmony-mattress/tech_md.webp": 1757,
	"./mattresses/harmony-mattress/tech_mob.webp": 1758,
	"./mattresses/harmony-mattress/tech_tab.webp": 1759,
	"./mattresses/harmony-mattress/tech_xl.webp": 1760,
	"./mattresses/helin_lg.webp": 1761,
	"./mattresses/helin_md.webp": 1762,
	"./mattresses/helin_mob.webp": 1763,
	"./mattresses/helin_tab.webp": 1764,
	"./mattresses/helin_xl.webp": 1765,
	"./mattresses/legacy-mattress/hero_lg.webp": 2700,
	"./mattresses/legacy-mattress/hero_md.webp": 2701,
	"./mattresses/legacy-mattress/hero_mob.webp": 2702,
	"./mattresses/legacy-mattress/hero_tab.webp": 2703,
	"./mattresses/legacy-mattress/hero_xl.webp": 2704,
	"./mattresses/legacy-mattress/legacy_lg.mp4": 1766,
	"./mattresses/legacy-mattress/legacy_md.mp4": 1767,
	"./mattresses/legacy-mattress/legacy_mob.mp4": 1768,
	"./mattresses/legacy-mattress/legacy_tab.mp4": 1769,
	"./mattresses/legacy-mattress/legacy_xl.mp4": 1770,
	"./mattresses/legacy-mattress/scheme_lg.webp": 1771,
	"./mattresses/legacy-mattress/scheme_md.webp": 1772,
	"./mattresses/legacy-mattress/scheme_mob.webp": 1773,
	"./mattresses/legacy-mattress/scheme_tab.webp": 1774,
	"./mattresses/legacy-mattress/scheme_xl.webp": 1775,
	"./mattresses/legacy-mattress/support_lg.webp": 1776,
	"./mattresses/legacy-mattress/support_md.webp": 1777,
	"./mattresses/legacy-mattress/support_mob.webp": 1778,
	"./mattresses/legacy-mattress/support_tab.webp": 1779,
	"./mattresses/legacy-mattress/support_xl.webp": 1780,
	"./mattresses/legacy-mattress/tech_lg.webp": 1781,
	"./mattresses/legacy-mattress/tech_md.webp": 1782,
	"./mattresses/legacy-mattress/tech_mob.webp": 1783,
	"./mattresses/legacy-mattress/tech_tab.webp": 1784,
	"./mattresses/legacy-mattress/tech_xl.webp": 1785,
	"./mattresses/majesty-mattress/hero_lg.webp": 2705,
	"./mattresses/majesty-mattress/hero_md.webp": 2706,
	"./mattresses/majesty-mattress/hero_mob.webp": 2707,
	"./mattresses/majesty-mattress/hero_tab.webp": 2708,
	"./mattresses/majesty-mattress/hero_xl.webp": 2709,
	"./mattresses/majesty-mattress/majesty_lg.mp4": 1786,
	"./mattresses/majesty-mattress/majesty_md.mp4": 1787,
	"./mattresses/majesty-mattress/majesty_mob.mp4": 1788,
	"./mattresses/majesty-mattress/majesty_tab.mp4": 1789,
	"./mattresses/majesty-mattress/majesty_xl.mp4": 1790,
	"./mattresses/majesty-mattress/scheme_lg.webp": 1791,
	"./mattresses/majesty-mattress/scheme_md.webp": 1792,
	"./mattresses/majesty-mattress/scheme_mob.webp": 1793,
	"./mattresses/majesty-mattress/scheme_tab.webp": 1794,
	"./mattresses/majesty-mattress/scheme_xl.webp": 1795,
	"./mattresses/majesty-mattress/support_lg.webp": 1796,
	"./mattresses/majesty-mattress/support_md.webp": 1797,
	"./mattresses/majesty-mattress/support_mob.webp": 1798,
	"./mattresses/majesty-mattress/support_tab.webp": 1799,
	"./mattresses/majesty-mattress/support_xl.webp": 1800,
	"./mattresses/majesty-mattress/tech_lg.webp": 1801,
	"./mattresses/majesty-mattress/tech_md.webp": 1802,
	"./mattresses/majesty-mattress/tech_mob.webp": 1803,
	"./mattresses/majesty-mattress/tech_tab.webp": 1804,
	"./mattresses/majesty-mattress/tech_xl.webp": 1805,
	"./mattresses/sensotex_lg.webp": 1806,
	"./mattresses/sensotex_md.webp": 1807,
	"./mattresses/sensotex_mob.webp": 1808,
	"./mattresses/sensotex_tab.webp": 1809,
	"./mattresses/sensotex_xl.webp": 1810,
	"./mattresses/sleep_system.svg": 1262,
	"./minoris-pillow/cover-bg.webp": 2710,
	"./minoris-pillow/cover-product-mob.webp": 1811,
	"./minoris-pillow/cover-product.webp": 1812,
	"./minoris-pillow/details-product-mob.webp": 2711,
	"./minoris-pillow/details-product.webp": 2712,
	"./minoris-pillow/filler-bg.webp": 2713,
	"./minoris-pillow/hero-bg-mob.webp": 2714,
	"./minoris-pillow/hero-bg.webp": 2715,
	"./minoris-pillow/hero-product-mob.webp": 1813,
	"./minoris-pillow/hero-product.webp": 1814,
	"./minoris-pillow/slide-1-mob.webp": 1815,
	"./minoris-pillow/slide-1.webp": 1816,
	"./minoris-pillow/slide-2-mob.webp": 1817,
	"./minoris-pillow/slide-2.webp": 1818,
	"./minoris-pillow/slide-3-mob.webp": 1819,
	"./minoris-pillow/slide-3.webp": 1820,
	"./nobilis-pillow/cert-cover.webp": 1324,
	"./nobilis-pillow/cert-filler.webp": 1325,
	"./nobilis-pillow/cert-product-mob.webp": 1326,
	"./nobilis-pillow/cert-product.webp": 1327,
	"./nobilis-pillow/cover-bg.webp": 2716,
	"./nobilis-pillow/cover-product-mob.webp": 1821,
	"./nobilis-pillow/cover-product.webp": 1822,
	"./nobilis-pillow/details-product-mob.webp": 2717,
	"./nobilis-pillow/details-product.webp": 2718,
	"./nobilis-pillow/filler-bg.webp": 2719,
	"./nobilis-pillow/hero-bg-mob.webp": 2720,
	"./nobilis-pillow/hero-bg.webp": 2721,
	"./nobilis-pillow/hero-product-mob.webp": 1823,
	"./nobilis-pillow/hero-product.webp": 1824,
	"./nobilis-pillow/slide-1-mob.webp": 1825,
	"./nobilis-pillow/slide-1.webp": 1826,
	"./nobilis-pillow/slide-2-mob.webp": 1827,
	"./nobilis-pillow/slide-2.webp": 1828,
	"./nobilis-pillow/slide-3-mob.webp": 1829,
	"./nobilis-pillow/slide-3.webp": 1830,
	"./palazzo-duvet/cert-cover.webp": 1831,
	"./palazzo-duvet/cert-filler.webp": 1832,
	"./palazzo-duvet/cert-product-mob.webp": 1833,
	"./palazzo-duvet/cert-product.webp": 1834,
	"./palazzo-duvet/cover-bg.webp": 2722,
	"./palazzo-duvet/cover-product-mob.webp": 1835,
	"./palazzo-duvet/cover-product.webp": 1836,
	"./palazzo-duvet/details-product-mob.webp": 2723,
	"./palazzo-duvet/details-product.webp": 2724,
	"./palazzo-duvet/filler-bg.webp": 2725,
	"./palazzo-duvet/hero-bg-mob.webp": 2726,
	"./palazzo-duvet/hero-bg.webp": 2727,
	"./palazzo-duvet/hero-product-mob.webp": 1837,
	"./palazzo-duvet/hero-product.webp": 1838,
	"./palazzo-duvet/slide-1-mob.webp": 1839,
	"./palazzo-duvet/slide-1.webp": 1840,
	"./palazzo-duvet/slide-2-mob.webp": 1841,
	"./palazzo-duvet/slide-2.webp": 1842,
	"./palazzo-duvet/slide-3-mob.webp": 1843,
	"./palazzo-duvet/slide-3.webp": 1844,
	"./silk/icon-1.svg": 1845,
	"./silk/icon-2.svg": 1846,
	"./silk/icon-3.svg": 1847,
	"./silk/section-1-1.webp": 1848,
	"./silk/section-1-2.webp": 1849,
	"./silk/section-1-3.webp": 1850,
	"./silk/section-1-4.webp": 1851,
	"./silk/section-1-5.webp": 1852,
	"./silk/section-2-1.webp": 1853,
	"./silk/section-2-2.webp": 1854,
	"./silk/section-2-3.webp": 1855,
	"./silk/section-2-4.webp": 1856,
	"./silk/section-2-5.webp": 1857,
	"./silk/section-3-1.webp": 1858,
	"./silk/section-3-2.webp": 1859,
	"./silk/section-3-3.webp": 1860,
	"./silk/section-3-4.webp": 1861,
	"./silk/section-3-5.webp": 1862,
	"./silk/section-4-1.webp": 1863,
	"./silk/section-4-2.webp": 1864,
	"./silk/section-4-3.webp": 1865,
	"./silk/section-4-4.webp": 1866,
	"./silk/section-4-5.webp": 1867,
	"./silk/section-5-1.webp": 1868,
	"./silk/section-5-2.webp": 1869,
	"./silk/section-5-3.webp": 1870,
	"./silk/section-5-4.webp": 1871,
	"./silk/section-5-5.webp": 1872,
	"./silk/section-6.webp": 1873,
	"./sirius-pillow/cover-product-mob.webp": 1874,
	"./sirius-pillow/cover-product.webp": 1875,
	"./sirius-pillow/details-product-mob.webp": 2728,
	"./sirius-pillow/details-product.webp": 2729,
	"./sirius-pillow/ecoal.png": 1876,
	"./sirius-pillow/features-product-mob.webp": 1877,
	"./sirius-pillow/features-product.webp": 1878,
	"./sirius-pillow/hero-bg-mob.webp": 1879,
	"./sirius-pillow/hero-bg.webp": 1880,
	"./sirius-pillow/memory-bg-mob.webp": 1881,
	"./sirius-pillow/memory-bg.webp": 1882,
	"./sirius-pillow/real-example-mob.webp": 1883,
	"./sirius-pillow/real-example.webp": 1884,
	"./sovereign-pillow/cert-cover.webp": 1885,
	"./sovereign-pillow/cert-filler.webp": 1886,
	"./sovereign-pillow/cert-product-mob.webp": 1887,
	"./sovereign-pillow/cert-product.webp": 1888,
	"./sovereign-pillow/cover-bg.webp": 2730,
	"./sovereign-pillow/cover-product-mob.webp": 1889,
	"./sovereign-pillow/cover-product.webp": 1890,
	"./sovereign-pillow/details-product-mob.webp": 2731,
	"./sovereign-pillow/details-product.webp": 2732,
	"./sovereign-pillow/filler-bg.webp": 2733,
	"./sovereign-pillow/hero-bg-mob.webp": 2734,
	"./sovereign-pillow/hero-bg.webp": 2735,
	"./sovereign-pillow/hero-product-mob.webp": 1891,
	"./sovereign-pillow/hero-product.webp": 1892,
	"./sovereign-pillow/slide-1-mob.webp": 1893,
	"./sovereign-pillow/slide-1.webp": 1894,
	"./sovereign-pillow/slide-2-mob.webp": 1895,
	"./sovereign-pillow/slide-2.webp": 1896,
	"./sovereign-pillow/slide-3-mob.webp": 1897,
	"./sovereign-pillow/slide-3.webp": 1898,
	"./tables/hero-bg-md.webp": 2736,
	"./tables/hero-bg-mob.webp": 2737,
	"./tables/hero-bg-tab.webp": 2738,
	"./tables/hero-bg-xl.webp": 2739,
	"./tables/hero-bg-xxl.webp": 2740,
	"./tables/last-md.webp": 2741,
	"./tables/last-mob.webp": 2742,
	"./tables/last-tab.webp": 2743,
	"./tables/rare-1-md.webp": 1899,
	"./tables/rare-1-mob.webp": 2744,
	"./tables/rare-1-xl.webp": 1900,
	"./tables/rare-1-xxl.webp": 1901,
	"./tables/rare-1.webp": 2745,
	"./tables/rare-2-md.webp": 1902,
	"./tables/rare-2-tab.webp": 2746,
	"./tables/rare-2-xl.webp": 1903,
	"./tables/rare-2-xxl.webp": 1904,
	"./tables/rare-2.webp": 2747,
	"./tables/slide-1-md.webp": 1905,
	"./tables/slide-1-mob.webp": 1906,
	"./tables/slide-1-tab.webp": 1907,
	"./tables/slide-1-xl.webp": 1908,
	"./tables/slide-1-xxl.webp": 1909,
	"./tables/slide-1.webp": 2748,
	"./tables/slide-2-md.webp": 1910,
	"./tables/slide-2-mob.webp": 1911,
	"./tables/slide-2-tab.webp": 1912,
	"./tables/slide-2-xl.webp": 1913,
	"./tables/slide-2-xxl.webp": 1914,
	"./tables/slide-3-md.webp": 1915,
	"./tables/slide-3-mob.webp": 1916,
	"./tables/slide-3-tab.webp": 1917,
	"./tables/slide-3-xl.webp": 1918,
	"./tables/slide-3-xxl.webp": 1919,
	"./tables/slide-4-md.webp": 1920,
	"./tables/slide-4-mob.webp": 1921,
	"./tables/slide-4-tab.webp": 1922,
	"./tables/slide-4-xl.webp": 1923,
	"./tables/slide-4-xxl.webp": 1924,
	"./tables/table-bg-md.webp": 2749,
	"./tables/table-bg-mob.webp": 2750,
	"./tables/table-bg-tab.webp": 2751,
	"./tables/table-bg-xl.webp": 2752,
	"./tables/table-bg-xxl.webp": 2753,
	"./tables/unique-1-md.webp": 1925,
	"./tables/unique-1-mob.webp": 1926,
	"./tables/unique-1-tab.webp": 1927,
	"./tables/unique-1-xl.webp": 1928,
	"./tables/unique-1-xxl.webp": 1929,
	"./tables/unique-2-md.webp": 1930,
	"./tables/unique-2-mob.webp": 1931,
	"./tables/unique-2-tab.webp": 1932,
	"./tables/unique-2-xl.webp": 1933,
	"./tables/unique-2-xxl.webp": 1934,
	"./tables/unique-mob.webp": 2754,
	"./tables/unique-tab.webp": 2755
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1243;